var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolPlusBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Racing/Icon/20x20px/Plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/20x20px/Plus"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/plus",
    transform: "translate(5.000000, 5.000000)",
    fill: "#6176A0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.83772264,0.0119315419 C4.39130561,0.0825823395 4.05058289,0.458492602 4.05058289,0.911618098 L4.04937101,4.1023773 L0.934597906,4.10276074 C0.418433735,4.10276074 0,4.50876019 0,5.00958589 L0.0122323088,5.15667764 C0.0846640514,5.58755149 0.470050152,5.91641104 0.934597906,5.91641104 L4.04937101,5.91505624 L4.05058289,9.0883819 C4.05058289,9.59185468 4.47122822,10 4.99012053,10 L5.14251842,9.98806846 C5.58893545,9.91741766 5.92965817,9.5415074 5.92965817,9.0883819 L5.92936837,5.91505624 L9.06540209,5.91641104 C9.58156626,5.91641104 10,5.51041159 10,5.00958589 L9.98776769,4.86249414 C9.91533595,4.43162029 9.52994985,4.10276074 9.06540209,4.10276074 L5.92936837,4.1023773 L5.92965817,0.911618098 C5.92965817,0.408145325 5.50901284,0 4.99012053,0 L4.83772264,0.0119315419 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-216.000000, -28.000000)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPlusBlue);
export default __webpack_public_path__ + "static/media/symbol_plus_blue.1b398608e2b41eda4e9c6b0979d881c2.svg";
export { ForwardRef as ReactComponent };